import { useEffect, useRef, useState } from "react";
import { ReactFlow } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { nodes, nodeTypes } from "./nodes";
import { edges, edgeTypes } from "./edges";

export default function ZtgmDiagram() {
  const wrapperRef = useRef(null);
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const flowPane = wrapper.querySelector(".react-flow__pane");
    if (!flowPane) return;

    const preventWheel = (e) => {
      if (e.ctrlKey || e.metaKey || e.shiftKey) return; // allow zoom gestures
      e.stopPropagation(); // stop RF from seeing it
    };

    flowPane.addEventListener("wheel", preventWheel, { passive: false });

    return () => {
      flowPane.removeEventListener("wheel", preventWheel);
    };
  }, [size]);

  return (
    <div
      ref={wrapperRef}
      className="ztgm-container"
    >
      <ReactFlow
        key={`${size.width}-${size.height}`} // Force remount on resize
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        zoomOnScroll={false}
        panOnScroll={false}
        panOnDrag={false}
        zoomOnPinch={false}
        zoomOnDoubleClick={false}
        selectionOnDrag={false}
        fitView
      />
    </div>
  );
}
